import { PATHS } from '~/routes/paths'
import { FlipperKey } from '~/store/flippers/types'
import { COUNTRY } from '~/managers/ConfigManager'
import {
  USER_ROLES,
  WALLET_TYPES,
  BusinessVerificationStatus,
  PersonalVerificationStatus,
  FundPoolTypes,
} from '~/types'
import { StateFlippers } from './reducer'

type StateFlipperKey = keyof StateFlippers

export type FlipperResponseMap = Record<FlipperKey, StateFlipperKey>

export type FeatureMatrix = {
  userRole: USER_ROLES | null
  country: COUNTRY
  availableWallets: WALLET_TYPES[]
  businessVerificationStatus: BusinessVerificationStatus
  personalVerificationStatus: PersonalVerificationStatus
  availableFundPools: FundPoolTypes[]
  companyTxnVolume: number
  isIdentificationDone: boolean
}

export type User = {
  authServerUrl: string
  email: string
  mobileNumber: string
  kcId: string
  bizId: string
  isFiatWalletOnly: boolean
  kycFullName: string
  businessLegalName: string
  twoFa: {
    isOnCoolingDownPeriod: boolean
    twoFaList: {
      credential: {
        id: string
        type: string
        userLabel: string
        createdDate: number
        credentialData: Record<string, unknown>
      }
    }[]
    twoFaSetupTime: string
  }
  isStablecoinTransferDisclaimerAcknowledged: boolean
  isDashboardRevampTourAcknowledged: boolean
  bannerDismissalState: {
    [key: string]: boolean
  }
  isFiatWithdrawalApprovalFlowEnabled: boolean
  isStablecoinWithdrawalApprovalFlowEnabled: boolean
}

export enum ROUTE_ACTIONS {
  SET_USER_PROFILE = 'ROUTE_ACTIONS.SET_USER_PROFILE',
  SET_ACKNOWLEDGE_DASHBOARD_REVAMP = 'ROUTE_ACTIONS.SET_ACKNOWLEDGE_DASHBOARD_REVAMP', // TODO(benedictkhoo): remove after unification project is completed
  SET_ACKNOWLEDGE_TRANSFER_DISCLAIMER = 'ROUTE_ACTIONS.SET_ACKNOWLEDGE_TRANSFER_DISCLAIMER',
  SET_ACKNOWLEDGE_DIRECT_MINT_EDUCATIONAL_BANNER = 'ROUTE_ACTIONS.SET_ACKNOWLEDGE_DIRECT_MINT_EDUCATIONAL_BANNER',
  SET_ACKNOWLEDGE_ANTI_SCAM = 'ROUTE_ACTIONS.SET_ACKNOWLEDGE_ANTI_SCAM',
  SET_REDIRECT = 'ROUTE_ACTIONS.SET_REDIRECT',
  SET_FLIPPERS = 'ROUTE_ACTIONS.SET_FLIPPERS',
  SET_USER_KC_ID = 'ROUTE_ACTIONS.SET_USER_KC_ID', // TODO(benedictkhoo): remove after unification project is completed
  SET_USER_BIZ_ID = 'ROUTE_ACTIONS.SET_USER_BIZ_ID', // TODO(benedictkhoo): remove after unification project is completed
}

type SetUserProfile = {
  type: typeof ROUTE_ACTIONS.SET_USER_PROFILE
  user: User
}

type SetAcknowledgeDashboardRevamp = {
  type: typeof ROUTE_ACTIONS.SET_ACKNOWLEDGE_DASHBOARD_REVAMP
}

type SetAcknowledgeTransferDisclaimer = {
  type: typeof ROUTE_ACTIONS.SET_ACKNOWLEDGE_TRANSFER_DISCLAIMER
  isStablecoinTransferDisclaimerAcknowledged: boolean
}

type SetRedirect = {
  type: typeof ROUTE_ACTIONS.SET_REDIRECT
  to: PATHS | null
}

type SetFlippers = {
  type: typeof ROUTE_ACTIONS.SET_FLIPPERS
  flippers: Map<keyof StateFlippers, boolean>
}

// TODO(benedictkhoo): remove after unification project is completed
export type SetUserKcId = {
  type: typeof ROUTE_ACTIONS.SET_USER_KC_ID
  kcId: string
}

// TODO(benedictkhoo): remove after unification project is completed
export type SetUserBizId = {
  type: typeof ROUTE_ACTIONS.SET_USER_BIZ_ID
  bizId: string
}

type SetAcknowledgeDirectMintEducationalBanner = {
  type: typeof ROUTE_ACTIONS.SET_ACKNOWLEDGE_DIRECT_MINT_EDUCATIONAL_BANNER
}

type SetAcknowledgeAntiScam = {
  type: typeof ROUTE_ACTIONS.SET_ACKNOWLEDGE_ANTI_SCAM
}

export type ActionTypes =
  | SetUserProfile
  | SetAcknowledgeDashboardRevamp
  | SetAcknowledgeTransferDisclaimer
  | SetAcknowledgeDirectMintEducationalBanner
  | SetAcknowledgeAntiScam
  | SetRedirect
  | SetFlippers
  | SetUserKcId
  | SetUserBizId
